import GET_ARTICLES from "../plugins/getArticles"
import GET_CATEGORIES from "../plugins/getCategories"

const [ w, d, content, mq ] = [ window, document, 'case', window.matchMedia("(max-width: 900px)") ]

const replace_item = obj => {
  let href = obj.getAttribute('href')
  let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
  let is_new = obj.querySelectorAll('span.new').length > 0 ? true : false
  let catObj = obj.querySelector('.catetitle a')
  let cat = catObj ? catObj.innerText : ''
  let dateObj = obj.querySelector('p.date')
  let date = dateObj ? dateObj.innerText : false
  let title = obj.querySelector('h5 > a').getAttribute('title')
  let desc = obj.querySelector('p.catch')? obj.querySelector('p.catch').innerText : ''

  $(obj).replaceWith(`
  <a href="${href}" class="${content}-item">
    <div class="${content}-item__row">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url(${thumb})">
          <img src="${thumb}" width="200" decoding="async">
        </div>
      </figure>
      <div class="${content}-item__body">
        ${cat ? `<span class="cate">${cat}</span>`: ''}
        <h3 class="subject">${title.str_truncate(32)}</h3>
        <span class="desc">${desc.str_truncate(42)}</span>
        <div class="btnwrap">
          <button class="button c-btn-icon-right-circle button-dark"><span>View More</span></button>
        </div>
      </div>
    </div>
  </a>
  `)
}

const init  = () => {

}

const list_init = (cat=false) => {
  $('.contents .wrapLink', '.element_list').each((i, obj) => replace_item(obj) );

  // カテゴリ一覧取得
  $(`<div class="${content}-catelist" data-plugin="getCategories" data-content="${content}"><p class="text-center"><i class="fa fa-circle-o-notch fa-spin text-grey fa-fw"></i>&nbsp;Loading...</p></div>`).insertAfter('.breadcrumbs');
  GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`, { content, addAll: true, itemClass: 'button' } );
}


// 詳細ページにて実行
const detail_init = async post_id => {
  let the_article = await $.getArticles({ content, post_id, post_status: 'all' });
  let categories = await $.getCategories({ content });
  the_article = the_article.shift();
  the_article.category = categories.filter( c => c.id == the_article.category ).shift();

  // タグボックス
  let tags = keywords => {
    let html = ""
    if(!keywords || keywords.length == 0) return ''
    keywords.forEach( key => html += `<a href="/${content}/?mode=list&tag=${ encodeURI( key ) }" class="tag">#${key}</a>` )
    return `<div class="${content}-detail__tags">${html}</div>`
  }

  // 詳細置き換え
  $('.element_detail').each( ( i, elm_detail ) => {
    let $head = $(`
      <div class="${content}-detail-head">
        <div class="${content}-detail-head__row">
          <figure class="${content}-detail-head__img">
            <div class="${content}-detail-head__img-cover" style="background-image:url(${the_article.thumb})">
              <img src="${the_article.thumb}" alt="${the_article.title}" width="110" loading="lazy">
            </div>
          </figure>
          <div class="${content}-detail-head__bodyWrap">
            <div class="${content}-detail-head__body">
              ${the_article.category ? `<span class="cate">${the_article.category.name}</span>`: '<span class="cate">その他</span>' }
              <h3 class="${content}-detail-head__title">${the_article.title}</h3>
              <span class="desc">${the_article.desc}</span>
            </div>
          </div>
        </div>
      </div>
    `)
    $('.element_detail > .title, .detail_title').remove()

    $head.prependTo( elm_detail )

    //記事フッター
    const detailFoot = $.get('/asset/html/case-detail-foot.html');
    detailFoot.done( html => {
      $('.element_detail .contents').append(html);

      $.when( w.load['case-detail-foot'] ).then( () => {

        // 関連一覧取得
        let makeItem = item =>  $(`
          <a href="${item.href}" class="${content}-item">
            <div class="${content}-item__row">
              <figure class="${content}-item__img">
                <div class="${content}-item__img-cover" style="background-image:url(${item.thumb})">
                  <img src="${item.thumb}" width="200" decoding="async">
                </div>
              </figure>
              <div class="${content}-item__body">
                <span class="cate">${item.category.name}</span>
                <h3 class="subject">${item.title.str_truncate(32)}</h3>
                <span class="desc">${item.desc.str_truncate(42)}</span>
                <div class="btnwrap">
                  <button class="button c-btn-icon-right-circle button-dark"><span>View More</span></button>
                </div>
              </div>
            </div>
          </a>
        `)[0]
        GET_ARTICLES( '.case-related__list[data-plugin="getArticles"]', {
          makeItem,
          exclude: the_article.id,
          cat: the_article.category.id
        });

        // カテゴリ一覧取得
        $(`<div class="${content}-catelist" data-plugin="getCategories" data-content="${content}"><p class="text-center"><i class="fa fa-circle-o-notch fa-spin text-grey fa-fw"></i>&nbsp;Loading...</p></div>`).insertAfter('.case-related');
        GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`, { content, addAll: true, itemClass: 'button' } );
      });
    });
  })

}


export default function CASE () {

  $(() => {
    init()
    if( w.query_string('mode') == 'list' || $('.element_list').length ) list_init( w.query_string('cat') );
    if( w.query_string('article') || $('.element_detail').length ) detail_init( w.query_string('article') );
  });
}